export class RRAvatar {
  fileUrl: string;
  base64Thumbnail?: string;
}
